import { useMemo } from 'react';

import { useGetSharedFunctionality } from '../../../api/lending/lapiHooks';

/**
 * Custom hook that checks if user is opted into the non-linear security checks flow.
 * @returns Whether the user is opted into the non-linear security checks flow.
 */
export const useIsNonLinearFlow = () => {
  const { functionality, loadingFunctionality } = useGetSharedFunctionality();

  const isNonLinearFlow = useMemo(
    () =>
      !loadingFunctionality &&
      Boolean(functionality?.iwocapay_non_linear_security_switch) &&
      Boolean(functionality?.is_non_linear_security_checks_enabled),
    [
      loadingFunctionality,
      functionality?.iwocapay_non_linear_security_switch,
      functionality?.is_non_linear_security_checks_enabled,
    ],
  );

  return {
    isNonLinearFlow,
    loading: loadingFunctionality,
  };
};
